import Button from '@mui/material/Button'
import { useFormikContext } from 'formik'
import React, { useCallback } from 'react'
import { ApolloQueryResult } from '@apollo/client'
import { mapHealthQuestionnaireToForm } from './initialValues/healthQuestionnaireTransform'
import { GetIntakeNoteComprehensivePatientDataQuery } from './initialValues/getIntakeNoteComprehensivePatientData.generated'

export function ReloadHealthQuestionnaire({
  refetch,
}: {
  refetch?: () => Promise<ApolloQueryResult<GetIntakeNoteComprehensivePatientDataQuery>>
}) {
  const { setFieldValue } = useFormikContext()

  const reloadHealthQuestionnaire = useCallback(async () => {
    if (!refetch) return

    const result = await refetch()
    const healthQuestionnaire = mapHealthQuestionnaireToForm(
      result.data?.intakeNoteComprehensivePatientData?.healthQuestionnaire
    )
    setFieldValue('REASON_FOR_SEEKING_TREATMENT.HEALTH_QUESTIONNAIRE', healthQuestionnaire)
  }, [refetch, setFieldValue])

  return (
    <Button variant="outlined" color="secondary" onClick={reloadHealthQuestionnaire}>
      Reload Health Questionnaire
    </Button>
  )
}
